module.exports = __webpack_public_path__ + "static/media/luxury.d00dcde8.jpg";